import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

// Matches @handle (letters, numbers, _ . -) not preceded by a word char or @
const HANDLE_RE = /(^|[^\w@])@([a-zA-Z0-9_.-]{2,32})/g;

/**
 * Render text with @handles converted into underlined links to `/u/:handle`.
 * Trailing punctuation (._-) is trimmed off the handle target but kept visually.
 */
export function linkifyHandles(
	text: string,
	opts?: { onClick?: (e: React.MouseEvent) => void; className?: string },
): ReactNode {
	if (!text) return text;
	const parts: ReactNode[] = [];
	let last = 0;
	let m: RegExpExecArray | null;
	HANDLE_RE.lastIndex = 0;
	let key = 0;
	while ((m = HANDLE_RE.exec(text)) !== null) {
		const [full, lead, raw] = m;
		const start = m.index + lead.length;
		if (start > last) parts.push(<Fragment key={`t${key++}`}>{text.slice(last, start)}</Fragment>);
		// Strip trailing punctuation from routing target only
		const cleanHandle = raw.replace(/[._-]+$/, '');
		const trailing = raw.slice(cleanHandle.length);
		parts.push(
			<Link
				key={`h${key++}`}
				to={`/u/${cleanHandle}`}
				onClick={(e) => {
					e.stopPropagation();
					opts?.onClick?.(e);
				}}
				className={
					opts?.className ??
					'underline decoration-active-gold/60 underline-offset-2 hover:decoration-active-gold text-foreground'
				}
			>
				@{cleanHandle}
			</Link>,
		);
		if (trailing) parts.push(<Fragment key={`p${key++}`}>{trailing}</Fragment>);
		last = m.index + full.length;
	}
	if (last < text.length) parts.push(<Fragment key={`t${key++}`}>{text.slice(last)}</Fragment>);
	return <>{parts}</>;
}
